"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Mutex. Makes sure a certain function
 * is not executed concurrently, even if it contains async operations..
 */
var Mutex = /** @class */ (function () {
    function Mutex() {
        this.queue = [];
    }
    /**
     * Makes sure the given callback is executed only after all
     * previous invocations of sync have finished.
     * @param fun The function to call. Can emit a promise.
     */
    Mutex.prototype.sync = function (fun) {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                promise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var _a, fun_1, resolve_1, reject_1, res, err_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                this.queue.push({
                                    fun: fun,
                                    resolve: resolve,
                                    reject: reject
                                });
                                if (!(this.queue.length === 1)) return [3 /*break*/, 6];
                                _b.label = 1;
                            case 1:
                                if (!(this.queue.length > 0)) return [3 /*break*/, 6];
                                _a = this.queue[0], fun_1 = _a.fun, resolve_1 = _a.resolve, reject_1 = _a.reject;
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 4, , 5]);
                                return [4 /*yield*/, fun_1()];
                            case 3:
                                res = _b.sent();
                                resolve_1(res);
                                return [3 /*break*/, 5];
                            case 4:
                                err_1 = _b.sent();
                                reject_1(err_1);
                                return [3 /*break*/, 5];
                            case 5:
                                this.queue.shift();
                                return [3 /*break*/, 1];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/, promise];
            });
        });
    };
    return Mutex;
}());
exports.Mutex = Mutex;
/**
 * Synchronized decorator which can patch methods on the fly.
 * Only works for methods, not for functions!
 */
function synchronized(target, methodName, descriptor) {
    var sync = new Mutex();
    if (descriptor === undefined) {
        descriptor = Object.getOwnPropertyDescriptor(target, methodName);
    }
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return sync.sync(function () { return originalMethod.apply(_this, args); });
    };
    return descriptor;
}
exports.synchronized = synchronized;
/**
 * Dictionary of mutexes.
 */
var MutexLibrary = /** @class */ (function () {
    function MutexLibrary() {
        this.dict = {};
    }
    /**
     * Fetches a mutex for the given key.
     * @param key The key.
     */
    MutexLibrary.prototype.by = function (key) {
        if (this.dict[key] === undefined) {
            this.dict[key] = new Mutex();
        }
        return this.dict[key];
    };
    return MutexLibrary;
}());
exports.MutexLibrary = MutexLibrary;
